export default __webpack_public_path__ + "static/media/nt_sunny.34a831c6.svg";